import HttpError from 'core/exceptions/httpError';

export default class HttpConflictError extends HttpError {}
